import { loginPopupHandler } from "../../../redux/features/auth/loginSlice";

/**
 * Property intelligence credit actions are for customers only (same as wallet / credits).
 *
 * @param {import("@reduxjs/toolkit").Dispatch} dispatch
 * @returns {"ok" | "need_login" | "wrong_account"}
 */
export function intelligenceCustomerGate(dispatch) {
  const loginMode = localStorage.getItem("loginMode");
  if (loginMode && loginMode !== "customer") {
    return "wrong_account";
  }

  try {
    const raw = localStorage.getItem("token");
    if (!raw) {
      dispatch(loginPopupHandler(true));
      return "need_login";
    }
    const token = JSON.parse(raw);
    if (!token) {
      dispatch(loginPopupHandler(true));
      return "need_login";
    }
  } catch {
    dispatch(loginPopupHandler(true));
    return "need_login";
  }

  return "ok";
}
